/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  publishDate: {
    id: `${scope}.publishDate`,
    defaultMessage: 'Last Publish',
  },
  author: {
    id: `${scope}.author`,
    defaultMessage: 'Author',
  },
  version: {
    id: `${scope}.version`,
    defaultMessage: 'Oculus Ver',
  },
  bookId: {
    id: `${scope}.bookId`,
    defaultMessage: 'Book ID',
  },
  tocLevel: {
    id: `${scope}.tocLevel`,
    defaultMessage: 'TOC Level',
  },
  inReview: {
    id: `${scope}.inReview`,
    defaultMessage: 'In Review',
  },
  publishedLive: {
    id: `${scope}.publishedLive`,
    defaultMessage: 'Published Live',
  },
  EPUB_ETEXT: {
    id: `${scope}.ePub`,
    defaultMessage: 'Pearson+ ePub',
  },
  BRONTE_PEARSON_PLUS: {
    id: `${scope}.pearsonPlus`,
    defaultMessage: 'Pearson+ Bronte Viewer',
  },
});
